// assets/bundle-deals.js
(function () {
  function moneyFormat(cents, symbol) {
    // Shopify fiyatları genelde cent cinsindedir (integer).
    // Bazı temalarda number gelebilir; ikisini de ele al.
    const val = typeof cents === 'number' ? cents : parseFloat(cents || 0);
    const asFloat = Math.round(val) / 100;
    return (symbol || '') + asFloat.toFixed(2);
  }

  function findVariantIdByOptions(variants, selects) {
    if (!variants || !Array.isArray(variants)) return null;
    // Seçilen option değerleri ile eşleşen varyantı bul
    const selected = Array.from(selects).map(sel => sel.value);
    const v = variants.find(vr => {
      const options = [vr.option1, vr.option2, vr.option3].filter(Boolean);
      if (options.length !== selected.length) return false;
      for (let i = 0; i < options.length; i++) {
        if (String(options[i]) !== String(selected[i])) return false;
      }
      return true;
    });
    return v ? v.id : null;
  }

  function initBundle(el) {
    if (!el) return;

    const percentLeft = parseFloat(el.dataset.percentageLeft || '1'); // örn: 0.9 (yani %10 indirim)
    const fixedDiscount = parseFloat(el.dataset.fixedDiscount || '0'); // cent
    const currency = el.dataset.currencySymbol || '';
    const enablePriceChanges = el.dataset.updatePrices === 'true';

    const totalPriceEl = el.querySelector('.bundle-deals__total-price-js');
    const totalCompareEl = el.querySelector('.bundle-deals__total-compare-price-js');
    const itemCheckboxes = el.querySelectorAll('.bundle-deals__checkbox-js');
    const productBlocks = el.querySelectorAll('.bundle-deals__product');
    const form = el.querySelector('product-form form');

    function blockElements(index) {
      const wrap = el.querySelector(`.bundle-deals__product [data-index="${index}"]`)?.closest('.bundle-deals__product');
      return {
        checkbox: el.querySelector(`.bundle-deals__checkbox-js[data-index="${index}"]`),
        priceEl: wrap?.querySelector('.bundle-deals__price-js'),
        compareEl: wrap?.querySelector('.bundle-deals__compare-price-js'),
        selectsWrap: el.querySelector(`.bundle-deals__variant-selects-js[data-index="${index}"]`)
      };
    }

    function recalcTotals() {
      let sumPrice = 0;
      let sumCompare = 0;

      itemCheckboxes.forEach(cb => {
        if (!cb.checked) return;
        const p = parseFloat(cb.dataset.price || '0');
        const cp = parseFloat(cb.dataset.comparePrice || '0');
        sumPrice += p;
        sumCompare += Math.max(p, cp); // karşılaştırma fiyatı yoksa p’yi baz al
      });

      // Section genel indirimi uygula
      const total = Math.max(0, Math.round(sumPrice * percentLeft - fixedDiscount));

      if (totalPriceEl) totalPriceEl.textContent = moneyFormat(total, currency);
      if (totalCompareEl) {
        if (sumCompare > total) {
          totalCompareEl.textContent = moneyFormat(sumCompare, currency);
          totalCompareEl.style.display = '';
        } else {
          totalCompareEl.textContent = '';
          totalCompareEl.style.display = 'none';
        }
      }
    }

    // Varyant değişimlerinde ilgili checkbox’ın price / comparePrice değerlerini güncelle
    function wireVariantPickers() {
      productBlocks.forEach((block, i) => {
        const selectsWrap = block.querySelector(`.bundle-deals__variant-selects-js[data-index="${i}"]`);
        if (!selectsWrap) return;

        const selects = selectsWrap.querySelectorAll('select');
        const variantsJSON = selectsWrap.querySelector('script[type="application/json"]');
        let variants = [];
        try {
          variants = JSON.parse(variantsJSON?.textContent || '[]');
        } catch (e) {}

        function onChange() {
          const id = findVariantIdByOptions(variants, selects);
          const checkbox = block.querySelector(`.bundle-deals__checkbox-js[data-index="${i}"]`);
          if (!checkbox) return;

          const variant = variants.find(v => v.id === id) || variants[0];
          if (!variant) return;

          // Block bazlı indirimleri Liquid önceden hesaplıyor olabilir; 
          // ancak enablePriceChanges true ise front-end’de güncelleyelim.
          // Checkbox’ta zaten data-price var; onu varyant fiyatına göre güncelle.
          const percentLeftBlock = 1; // block bazlı ekstra oran kullanıyorsan burada uygula
          const fixedBlock = 0;

          const variantPrice = parseFloat(variant.price || 0);        // cent
          const variantCompare = parseFloat(variant.compare_at_price || variant.price || 0);

          const newPrice = Math.max(0, Math.round(variantPrice * percentLeftBlock - fixedBlock));

          checkbox.dataset.id = String(variant.id);
          checkbox.dataset.price = String(newPrice);
          checkbox.dataset.comparePrice = String(variantCompare);

          // UI fiyatlarını güncelle
          const { priceEl, compareEl } = blockElements(i);
          if (priceEl) priceEl.textContent = moneyFormat(newPrice, currency);
          if (compareEl) {
            if (variantCompare > newPrice) {
              compareEl.textContent = moneyFormat(variantCompare, currency);
              compareEl.style.display = '';
            } else {
              compareEl.textContent = '';
              compareEl.style.display = 'none';
            }
          }
          recalcTotals();
        }

        selects.forEach(sel => sel.addEventListener('change', onChange));
        onChange(); // ilk yüklemede senkronize et
      });
    }

    // Checkbox değişimlerini dinle
    itemCheckboxes.forEach(cb => cb.addEventListener('change', recalcTotals));

    // Form submit → birden fazla ürünü tek istekle sepete ekle
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const skipCart = el.querySelector('.product-variant-id')?.dataset?.skipCart === 'true';

        const items = [];
        itemCheckboxes.forEach(cb => {
          if (!cb.checked) return;
          const id = parseInt(cb.dataset.id, 10);
          if (!id) return;
          items.push({ id, quantity: 1 });
        });

        if (!items.length) return;

        try {
          // /cart/add.js (AJAX) — çoklu ürün ekleme
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) throw new Error('Cart add failed');
        } catch (err) {
          console.error(err);
          return;
        }

        if (skipCart) {
          window.location.href = '/checkout';
        } else {
          // Tema çekmecesi varsa tetikleyebilirsin; yoksa sepet sayfasına yönlendir:
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch (_) {}
          window.location.href = '/cart';
        }
      });
    }

    // İlk hesap
    wireVariantPickers();
    recalcTotals();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bundle-deals').forEach(initBundle);
  });
})();
